import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
    Circle as CircleIcon,
    Warning as WarningIcon,
    CheckCircle as CheckCircleIcon,
    Error as ErrorIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

const StyledBadge = styled(Box)(({ theme, status }) => {
    const statusStyles = {
        active: {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
        ready: {
            color: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
        pending: {
            color: theme.palette.warning.main,
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
        draft: {
            color: theme.palette.status.legal,          // '#4A2C8A' from theme
            backgroundColor: alpha(theme.palette.status.legal, 0.1),
        },
        overdue: {
            color: theme.palette.error.main,
            backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
        settled: {
            color: theme.palette.success.main,
            backgroundColor: alpha(theme.palette.success.main, 0.1),
        },
        legal: {
            color: theme.palette.status.legal,
            backgroundColor: alpha(theme.palette.status.legal, 0.1),
        },
    };

    const style = statusStyles[status] || statusStyles.active;

    return {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: theme.shape.borderRadius,
        fontSize: '0.75rem',
        fontWeight: 600,
        color: style.color,
        backgroundColor: style.backgroundColor,
    };
});

const statusIcons = {
    active: CircleIcon,
    ready: CircleIcon,
    draft: WarningIcon,
    pending: WarningIcon,
    overdue: ErrorIcon,
    settled: CheckCircleIcon,
    legal: WarningIcon,
};

const LsStatusBadge = ({ status, label, showIcon = true, ...props }) => {
    const Icon = statusIcons[status] || CircleIcon;

    return (
        <StyledBadge status={status} {...props}>
            {showIcon && <Icon sx={{ fontSize: '1rem' }} />}
            <Typography variant="inherit">{label || status?.toUpperCase()}</Typography>
        </StyledBadge>
    );
};

export default LsStatusBadge;